/**
 * @author Sai Prasad
 * @class FaqsList
 */

import React from 'react';
import { useHistory } from 'react-router-dom';
import TileHeader from './TileHeader';
import { PATHS } from '../../common/constants';

const FaqsList = ({
    currentUserSuite,
    faqs
}) => {
    const history = useHistory();

    // function to navigate suite view.
    const navigateTo = () => {
        const url = {
            pathname: PATHS.SUITES_VIEW.replace(':id', currentUserSuite.propertyId + "&" + currentUserSuite.id),
            state: { suite: { id: currentUserSuite.id }, property: { id: currentUserSuite.propertyId }, activeTab: 6, from: 'Dashboard' }
        }
        history.push(url);
    }
    
    return (
        <div className='homeDasboard__mainTile'>
            <div style={{ padding: 20 }}>
                <TileHeader
                    heading='FAQS'
                    data={faqs}
                    onNavigate={navigateTo}
                />
                    <div className='homeDasboard__tile'>
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: '50%' }}>
                                <label className='homeDasboard__tableItem'>Question</label>
                            </div>
                            <div style={{ width: '50%' }}>
                                <label className='homeDasboard__tableItem'>Issue Type</label>
                            </div>
                        </div>
                        <div className='homeDasboard__list'>
                            {faqs.map((item, i) => {
                                return (
                                    <div className='homeDasboard__table' key={i}>
                                        <div style={{ display: 'flex' }}>
                                            <div style={{ width: '50%' }}>
                                                <label className='homeDasboard__activityText'>{item.question}</label>
                                            </div>
                                            <div style={{ width: '50%' }}>
                                                <label className='homeDasboard__date' style={{ paddingRight: 5 }}>{item.type}</label>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
            </div>
        </div>
    )
}

export default FaqsList;